import React, { Component, Suspense, lazy  } from "react";
import { Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component';

import Home from "Pages/Home";
import RFQCreate from "Pages/RFQ/RFQCreate";
import RFQDetails from "Pages/RFQ/RFQDetails";

import App from './App';
import Dashboard from "Pages/Dashboard";
import TransporterDashboard from "Pages/Dashboard/Transporters";
import RFQBids from "Pages/Contracting/RFQBids";
import TransportersListing from "Pages/Contracting/TransportersListing";
import TransporterDetail from "Pages/Contracting/TransporterDetail";
// import Signin from "Pages/Signin";
import GroupsAndTransporters from "Pages/Settings/GroupsAndTransporters";
// import ChallengePriceForm from "Pages/Contracting/ChallengePriceForm";
import Holistics from "Pages/Settings/Holistics";
import AllocationReport from "Pages/Settings/AllocationReport";
import MarketAnalysisReport from "Pages/Settings/MarketAnalysisReport";
import MarketAnalysisReportAccounts from "Pages/Settings/MarketAnalysisReportAccounts";
// import Forgotpassword from "Pages/Forgotpassword";
// import ResetPassword from "Pages/ResetPassword";
import EndToEndMis from "Pages/Settings/EndToEndMis";
import IndentMis from "Pages/Settings/IndentMis";

import InfringementPolicy from "Pages/Settings/InfringementPolicy";
import PrivacyPolicy from "Pages/Settings/PrivacyPolicy";
import TermsOfUse from "Pages/Settings/TermsOfUse";
import LiabilityDisclaimer from "Pages/Settings/LiabilityDisclaimer";
import ContactUs from "Pages/Settings/ContactUs";

import TransporterParticipation from "Pages/Settings/TransporterParticipation";
import ContractRecords from "Pages/ContractRecords";
import ContractRecordDetails from "Pages/ContractRecords/ContractRecordDetails";
import VoltasMis from "Pages/Settings/VoltasMis";
import TK11Dashboard from "Pages/Dashboard/tk11Dashboard";
import MultiModalReport from "Pages/Settings/MultiModalReport";
import TK11Efficiency from "Pages/Settings/Tk11EfficiencyDashboard";
import ManagementSummaryReport from "Pages/Settings/ManagementSummaryReport";
import PlantWiseReport from "Pages/Settings/PlantWiseReport";
import MultiModeContracts from "Pages/MultiModeContracts";
import ViewGeneratedContracts from "Pages/ViewMultiModeGeneratedContracts";
import FreightDetailsReport from "Pages/Settings/FreightDetailsReport";
import UploadPlan from "Pages/UploadPlan";
import ContractingShortMis from "Pages/Settings/ContractingShortMis";
import GoogleStudioDashboard from "Pages/Settings/GoogleStudioDashboard";
import HolisticsMis from "Pages/Settings/HolisticsMis";
import CargoTracking from "Pages/CargoTracking";
import ContractingIndentingMis from "Pages/Settings/ContractingIndentingMis";
import AWLMISReports from "Pages/AWLMISReports";
import ProviderTK11MIS from "Pages/Settings/ProviderTK11MIS";
import Dashboards from 'Pages/AwlDashboards';
import RouteMaster from "Pages/RouteMaster";
import GDashboard from "Pages/Settings/Dashboards";
import EventManagement from "Pages/EventManagement";
import NewEvent from "Pages/EventManagement/NewEvent";
import UploadRfq from "Pages/UploadRfq/index";
import PreviewEvent from "Pages/EventManagement/Preview/index";
import EventStatus from "Pages/EventManagement/Detailspage/eventStatus";
import EditEvent from "Pages/EventManagement/EditEvent";
import WinningTransporters from "Pages/EventManagement/WinningTransporters";
import CreateNewContracts from "Pages/CreateNewContracts/index";
import SingleCostEstimation from "Pages/singleCostEstimation/index";
import DbCostEstimation from "Pages/dbCostEstimation/index";
import MultiModeContractDetails from "Pages/ViewMultiModeGeneratedContracts/multiModeContractDetails";
import SecondaryContracts from "Pages/SecondaryContracts";
import AddSecondaryContracts from "Pages/AddSecondaryContracts";
import MultiContract from "Pages/MultiContract";
import ACCForRateComparison from "Pages/RateComparison/ACCForRateComparison";
import MultimodalRateComparison from "Pages/RateComparison/MultimodalRateComparison";
import DetailedCalculationForFreight from "Pages/RateComparison/DetailedCalculationForFreight​";
import EXIMCargoTracking from "Pages/EXIMCargoTracking/EXIMCargoTracking";
import SupplierOrTransportationRequestsDashboard from "Pages/SupplierOrTransportationRequestsDashboard/index";
import SupplierRFQCreateRequest from "Pages/SupplierRFQCreateOrUpdateRequest/index";
import LoginForm from "Pages/Login/Index"
import ChangePassword from "Pages/Login/ChangePassword"
import ResetPassword from "Pages/Login/ResetPassword";
import EXIMRFQCreate from "Pages/EXIMRFQ";

// const ChallengePriceForm = lazy(() => import('Pages/Contracting/ChallengePriceForm'));

const ChallengePriceForm = loadable(() => import('Pages/Contracting/ChallengePriceForm'));

export default class Routes extends Component {
  render() {
    return (
      <App>
        <Switch>
          {/* <Route exact path="/" component={Signin} /> */}
          <Route exact path="/" component={LoginForm} />
          <Route exact path="/rfq/type" component={Home} />
          <Route exact path="/rfq/create/:id/:type/:isCopy?" component={RFQCreate} />
          <Route exact path="/rfq/view/:id/:serviceType/:type" component={RFQCreate} />
          <Route exact path="/rfq/details/:id/:type" component={RFQDetails} />
          <Route exact path="/transporters/:id" component={TransporterDashboard} />
          <Route exact path="/transporters/" component={TransporterDashboard} />
          <Route exact path="/seeker" component={Dashboard} />
          <Route exact path="/seeker/bids/:id/:type" component={RFQBids} />
          {/* <Route exact path="/challengepriceform/:id" component={ChallengePriceForm} /> */}
          <Route exact path="/seeker/bids/:id/approval" component={RFQBids} />
          <Route exact path="/seeker/bids/transporters/list/:id" component={TransportersListing} />
          <Route exact path="/seeker/bids/transporters/detail/:rfqId/:transporterId/:rfqType" component={TransporterDetail} />
          <Route exact path="/groups/:type" component={GroupsAndTransporters} />
          <Route exact path="/holistics" component={Holistics} />
          <Route exact path="/allocationReport" component={AllocationReport} />
          <Route exact path="/marketAnalysisReport" component={MarketAnalysisReport} />
          <Route exact path="/MarketAnalysisReportAccounts" component={MarketAnalysisReportAccounts} />
          {/* <Route exact path="/forgotpassword" component={Forgotpassword}/>  */}
          <Route exact path="/forgot-password" component={ResetPassword}/> 

          {/* <Route exact path="/resetpassword" component={ResetPassword}/>  */}
          <Route exact path="/changepassword" component={ChangePassword}/> 

          <Route exact path="/endtoendmis" component={EndToEndMis}/> 
          <Route exact path="/indentmis" component={IndentMis}/>
          <Route exact path="/privacyPolicy" component={PrivacyPolicy}/>
          <Route exact path="/transporterParticipation" component={TransporterParticipation}/>
          <Route exact path="/contractRecords" component={ContractRecords}/>
          <Route exact path="/contractRecords/details/:id/:transporterId/:type" component={ContractRecordDetails}/>
          <Route exact path="/voltasmis" component={VoltasMis}/>
          <Route exact path="/tk11Dashboard/:id" component={TK11Dashboard} />
          <Route exact path="/infringementPolicy" component={InfringementPolicy} />
          <Route exact path="/termsOfUse" component={TermsOfUse} />
          <Route exact path="/liabilityDisclaimer" component={LiabilityDisclaimer} />
          <Route exact path="/contactUs" component={ContactUs} />
          <Route exact path="/multimodalmis" component={MultiModalReport} />
          <Route exact path="/tk11EfficiencyDashboard" component={TK11Efficiency} />
          <Route exact path="/managementSummarReport" component={ManagementSummaryReport} />
          <Route exact path="/plantWiseReport" component={PlantWiseReport} />
          <Route exact path="/multiModeContracts" component={MultiModeContracts} />
          <Route exact path="/viewGeneratedContracts" component={ViewGeneratedContracts} />
          <Route exact path="/freightDetailsReport" component={FreightDetailsReport} />
          <Route exact path="/uploadPlan" component={UploadPlan} />
          <Route exact path="/contractingShort" component={ContractingShortMis} />
          <Route exact path="/contractMonitoringDashboard" component={GoogleStudioDashboard} />
          <Route exact path="/report/:type" component={HolisticsMis} />
          <Route exact path="/cargoTracking" component={CargoTracking} />
          <Route exact path="/contractingIndentingMis" component={ContractingIndentingMis} />
          <Route exact path="/awlMISReports" component={AWLMISReports} />
          <Route exact path="/providerReport" component={ProviderTK11MIS} />
          <Route exact path="/dashboards" component={Dashboards} /> 
          <Route exact path="/routeMaster" component={RouteMaster} />
          <Route exact path="/gDashboard/:reportId" component={GDashboard} />
          <Route exact path="/eventManagement" component={EventManagement} />
          <Route exact path="/event/create/:eventId/:rfqId" component={NewEvent} />
          <Route exact path="/uploadRFQ/:eventId/:rfqId" component={UploadRfq} />
          <Route exact path="/preview/:eventId/:rfqId" component={PreviewEvent} />
          <Route exact path="/eventStatus/:eventId" component={EventStatus} />
          <Route exact path="/editEvent/:eventId/:rfqId/:parentId" component={EditEvent} />
          <Route exact path="/winningTransporters/:eventId" component={WinningTransporters} />
          <Route exact path="/createNewContracts" component={CreateNewContracts} />
          <Route exact path="/singleCostEstimation" component={SingleCostEstimation} />
          <Route exact path="/dbCostEstimation" component={DbCostEstimation} />
          <Route exact path="/viewContractDetails/:contractId" component={MultiModeContractDetails} />
          <Route exact path="/secondaryContracts" component={SecondaryContracts} />
          <Route exact path="/addSecondaryContract" component={AddSecondaryContracts} />
          <Route exact path="/contracts/:rfqId/:isView" component={AddSecondaryContracts} />
          <Route exact path="/multiContracts" component={MultiContract}/>
          {/* <Suspense fallback={<div>Loading...</div>}> */}
            <Route exact path="/challengepriceform/:id" component={ChallengePriceForm} />
          {/* </Suspense> */}
          <Route exact path="/multimodalRateComparison" component={MultimodalRateComparison} />
          <Route exact path="/detailedCalculationForFreight" component={DetailedCalculationForFreight} />
          <Route exact path="/EXIMCargoTracking" component={EXIMCargoTracking} />
          
  
          <Route exact path="/contracting/:type/transportationRequests" component={SupplierOrTransportationRequestsDashboard} />
          <Route exact path="/contracting/:type/supplierDashboard" component={SupplierOrTransportationRequestsDashboard} />
          <Route exact path="/contracting/:type/supplierRFQCreateOrUpdateRequest/:rfqId/:rfqType/:formType" component={SupplierRFQCreateRequest} />

          <Route exact path="/exim/rfq/create/:id/:type/:isCopy?" component={EXIMRFQCreate} />
          <Route exact path="/exim/rfq/view/:id/:serviceType/:type" component={EXIMRFQCreate} />

        </Switch> 
      </App>
    )
  }
}